import { Component, HostListener, ViewChild } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ModuleListComponent } from './module-list/module-list.component';
import { Utility } from '../../../core/utils/utility';
import { environment } from '../../../../../environments/environment';
import { PaginatorState } from '../../../core/models/paginator.model';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from '../../../lms/_services/course.service';
import { LessonsService } from '../../../lms/_services/lessons.service';
import { TeacherService } from '../../../lms/_services/teacher.service';
import { AuthService } from '../../../auth/_services/auth.service';
import { MessageService } from 'primeng/api';
import { Platform } from '@microsoft/signalr/dist/esm/Utils';
import { CommentType } from '../../../core/models/comment-type';
import { CompanyCommentService } from '../../../lms/_services/company-comment.service';
import { AssignmentsComponent } from './assignments/assignments.component';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { take } from 'rxjs/operators';
import { StartupProfileService } from '../../../panel/_services/startup-profile.service';
import { MessageModule } from 'primeng/message';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-lms-modules',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    NgbNavModule,
    DropdownModule,
    MessageModule,
    ModuleListComponent,
    AssignmentsComponent,
    AnnouncementsComponent
  ],
  templateUrl: './lms-modules.component.html',
  styleUrl: './lms-modules.component.scss',
  providers: [Platform]
})
export class LmsModulesComponent {
  // active = 1;

  url = environment.frontendUrl + '/' + this.router.url;
  loading: boolean = true;
  clicked: boolean = true;
  scrolled!: boolean;
  textShow: any = 'مشاهده بیشتر';
  svgshow: any = 'assets/icons/plus.svg'
  sentCode: boolean = false
  loadingbtn: boolean = false
  slides = [
    { img: "http://placehold.it/350x150/000000" },
    { img: "http://placehold.it/350x150/111111" },
    { img: "http://placehold.it/350x150/111111" },
  ];
  slideConfig = {
    "slidesToShow": 2,
    "slidesToScroll": 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },


    ]
  };

  courseTitle!: any;
  hlsFileUrl!: any;
  courseInformation!: any;
  paginator: PaginatorState = new PaginatorState();
  relatedCourses!: any;
  teachers: any = [];
  myForm!: FormGroup;
  comments: any = [];
  questionAndAnswer: any = [];
  questionAndAnswerStatus!: any;
  commentStatus!: any;
  page: number = 1;
  pageSize: number = 8;
  pageForQuestion: number = 1;
  pageSizeForQuestion: number = 8;
  questionForm!: FormGroup;
  currentUser: any = [];
  teaserShow: boolean = true;
  remainDays!: number;
  totalDay!: number;


  @ViewChild('description') descriptionTxt!: any;
  isOverHeight: boolean = false;
  fileServerUrl!: string;
  width!: any;
  fragment!: string | null;
  isFullScreen!: boolean;
  showFullScreenButton = true;
  isSmall: boolean;
  dataCourse: any;
  courseId: number | undefined;
  startup: any;
  startupId: any;
  
  // Admin startup selection properties
  dataStartups: any[] = [];
  selectedStartup: any;
  loadingStartups: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private courseService: CourseService,
    private router: Router,
    private lessonService: LessonsService,
    private teacherService: TeacherService,
    private companyCommentService: CompanyCommentService,
    private fb: FormBuilder,
    public authService: AuthService,
    private messageService: MessageService,
    public platform: Platform,
    private startupService: StartupProfileService
  ) {
    this.isSmall = window.innerWidth <= 1024;
    this.fileServerUrl = environment.fileServerUrl;

    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment || 'modules'; // Default to 'modules' tab if no fragment
    });

    this.paginator.page = 1;
    this.paginator.pageSize = 5;

    // Load startups for Admin users
    if (this.authService.isAdmin || this.authService.isTenantAdminOrOperator) {
      this.loadStartupsForAdmin();
    }

    this.route.queryParams.subscribe(params => {
      this.loading = true;
      if (params['startupid']) {
        if (this.startupId != params['startupid']) {
          this.startupId = params['startupid'];
          
          // Use appropriate method based on user role
          const courseObservable = (this.authService.isAdmin || this.authService.isTenantAdminOrOperator)
            ? courseService.getStartupCourseForAdmin({ 
                filter: { startupId: params['startupid'] },
                paginator: { page: 1, pageSize: 100 }
              })
            : courseService.getStartupCourses(params['startupid']);
          
          courseObservable.subscribe(res => {
            // Handle different response structures
            this.dataCourse = (this.authService.isAdmin || this.authService.isTenantAdminOrOperator) && (res as any)?.result ? (res as any).result : res;

            if (this.dataCourse.length) {
              if (this.dataCourse.length == 1) {
                this.courseId = this.dataCourse[0].courseId;
              }
              if (params['courseId']) {
                // Check if the courseId exists in this startup's courses
                const foundCourse = this.dataCourse.find((x: any) => x.courseId == params['courseId']);
                if (foundCourse) {
                  this.courseId = foundCourse.courseId;
                  this.getCourse(this.courseId as number, params['startupid']);
                } else {
                  // CourseId doesn't exist in this startup, use the first course
                  console.warn(`Course ID ${params['courseId']} not found in startup ${params['startupid']}, using first available course`);
                  this.courseId = this.dataCourse[0].courseId;
                  this.getCourse(this.courseId as number, params['startupid']);
                }
              } else {
                this.courseId = this.dataCourse[0].courseId;
                this.getCourse(this.courseId as number, params['startupid']);
              }
              // }
            } else {
              this.loading = false;
            }
          }, error => {
            console.error('Error loading courses:', error);
            this.loading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to load courses for this startup'
            });
          })
        } else {
          if (this.dataCourse.length) {
            if (this.dataCourse.length == 1) {
              this.courseId = this.dataCourse[0].courseId;
            }
            if (params['courseId']) {
              this.courseId = this.dataCourse.find((x: any) => x.courseId == params['courseId']).courseId;
              this.getCourse(this.courseId as number, params['startupid']);
            } else {
              this.courseId = this.dataCourse[0].courseId;
              this.getCourse(this.courseId as number, params['startupid']);
            }
          } else {
            this.loading = false;
          }
        }

      } else {
        if (this.dataCourse?.length) {
          if (this.dataCourse.length == 1) {
            this.courseId = this.dataCourse[0].courseId;
          }
          if (params['courseId']) {
            this.courseId = this.dataCourse.find((x: any) => x.courseId == params['courseId']).courseId;
            this.getCourse(this.courseId as number, params['startupid']);
          } else {
            this.courseId = this.dataCourse[0].courseId;
            this.getCourse(this.courseId as number, params['startupid']);
          }
        } else {
          // For Admin users, don't load bought courses - they need to select a startup
          if (this.authService.isAdmin || this.authService.isTenantAdminOrOperator) {
            this.loading = false;
            return;
          }
          
          this.courseService.getBoutCourse().subscribe((res: any) => {
            this.dataCourse = res['result'];

            if (this.dataCourse.length) {
              if (this.dataCourse.length == 1) {
                this.courseId = this.dataCourse[0].courseId;
              }
              this.route.queryParams.subscribe(params => {
                this.loading = true;

                if (params['courseId']) {
                  this.courseId = this.dataCourse.find((x: any) => x.courseId == params['courseId']).courseId;
                  this.getCourse(this.courseId as number, params['startupid']);
                } else {
                  this.courseId = this.dataCourse[0].courseId;
                  this.getCourse(this.courseId as number, params['startupid']);
                }
              });
            } else {
              this.loading = false;
            }
          });
        }
      }
    });

    // this.courseService.getBoutCourse().subscribe((res: any) => {
    //   this.dataCourse = res['result'];

    //   if (this.dataCourse.length) {
    //     if (this.dataCourse.length == 1) {
    //       this.courseId = this.dataCourse[0].courseId;
    //       // this.getCourse(this.courseId as number, null);
    //     }
    //     // else {
    //     this.route.queryParams.subscribe(params => {
    //       this.loading = true;

    //       if (params['courseId']) {
    //         this.courseId = this.dataCourse.find((x: any) => x.courseId == params['courseId']).courseId;
    //         this.getCourse(this.courseId as number, params['startupid']);
    //       } else {
    //         this.courseId = this.dataCourse[0].courseId;
    //         this.getCourse(this.courseId as number, params['startupid']);
    //       }
    //     });
    //     // }
    //   }
    // });
  }

  // Load startups for Admin users to select from
  loadStartupsForAdmin() {
    this.loadingStartups = true;
    const tableState = {
      paginator: { page: 1, pageSize: 100 }, // Get first 100 startups
      sorting: { column: 'CompanyName', direction: 'asc' }
    };
    
    this.startupService.getTableForAdmin(tableState).subscribe({
      next: (res: any) => {
        if (res && res.result) {
          this.dataStartups = res.result.map((startup: any) => ({
            title: startup.companyName,  // Use title to match HTML template
            id: startup.id,              // Use id to match HTML template
            ...startup
          }));

          // Set selectedStartup based on current startupId after startups are loaded
          if (this.startupId && (this.authService.isAdmin || this.authService.isTenantAdminOrOperator)) {
            // Convert both to string for comparison to handle type mismatches
            const foundStartup = this.dataStartups.find(s => String(s.id) === String(this.startupId));
            if (foundStartup) {
              this.selectedStartup = foundStartup.id;
            }
          }
        }
        this.loadingStartups = false;
      },
      error: (error) => {
        console.error('Error loading startups:', error);
        this.loadingStartups = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load startups list'
        });
      }
    });
  }

  // Handle startup selection for Admin
  onStartupSelect() {
    if (this.selectedStartup) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { 
          startupid: this.selectedStartup 
          // Remove courseId and other params when switching startups
        },
        fragment: 'modules' // Set default fragment to modules tab
      });
    }
  }

  ngOnInit(): void {
    // Ensure fragment is set for proper tab activation
    if (!this.fragment) {
      this.fragment = 'modules';
    }
  }

  tabChanged(e: any) {
    this.router.navigate(['.'], { relativeTo: this.route, fragment: e, queryParamsHandling: 'preserve' })
  }

  getCourse(courseId: number, startupid: string | null) {
    if (this.authService.isInRole('Founder')) {
      // Founder logic - get startup members and their assignments
      this.startupService.getForedit(startupid).subscribe(res => {
        this.startup = res;

        this.courseService.getById(courseId, this.startup?.members?.map((x: any) => x.id), startupid).subscribe((res: any) => {
          this.courseInformation = res;
          this.finalizeCourseLoad();
        });
      });
    } else if ((this.authService.isAdmin || this.authService.isTenantAdminOrOperator) && startupid) {
      // Admin logic - get course data for the startup scope (will include admin-submitted homework)
      this.courseService.getById(courseId, null, startupid).subscribe((res: any) => {
        this.courseInformation = res;
        this.finalizeCourseLoad();
      });
    }
  }

  private finalizeCourseLoad() {
    this.loading = false;

    this.isOverHeight = this.descriptionTxt?.nativeElement?.offsetHeight >= 150;

    this.teacherService.getByIds(this.courseInformation.teacherIds).subscribe(res => {
      this.teachers = res;
    });

    try {
      document.getElementById(this.fragment as string)?.scrollIntoView();
    } catch (e) { }
  }


  getComment() {
    this.companyCommentService.get({
      Type: CommentType.course,
      Value: this.courseId,
      Page: this.page,
      PageSize: this.pageSize
    }).subscribe((res: any) => {
      let data = [];
      data = res['result'];
      this.comments = this.comments.concat(data);
      this.commentStatus = res['totalCount'];
    });
  }

  getQuestionAndAnswer() {
    this.companyCommentService.get({
      Type: CommentType.question,
      Value: this.courseId,
      Page: this.pageForQuestion,
      PageSize: this.pageSizeForQuestion
    }).subscribe((res: any) => {
      let data = [];
      data = res['result'];
      this.questionAndAnswer = this.questionAndAnswer.concat(data);
      this.questionAndAnswerStatus = res['totalCount'];
    });
  }

  navigate() {
    this.router.navigate(['.'], { queryParams: { courseId: this.courseId }, relativeTo: this.route, preserveFragment: true, queryParamsHandling: 'merge' });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }


  @HostListener("window:scroll", [])
  onWindowScroll() {

    let someDiv = document.getElementById('someDiv');
    let distanceToTop = someDiv?.offsetTop;
    var top = document.documentElement.scrollTop;
    if (distanceToTop && distanceToTop < top) {
      this.scrolled = true
    } else {
      this.scrolled = false

    }

  }

  MoreText() {
    if (this.clicked) {
      this.textShow = 'مشاهده کمتر'
      this.svgshow = 'assets/icons/minus.svg'
      this.clicked = false
    } else {
      this.textShow = 'مشاهده بیشتر'
      this.svgshow = 'assets/icons/plus.svg'
      this.clicked = true
    }

  }

  buyPlan(course: any) {
    this.courseService.addToCart(course);
  }

  // @HostListener('window:orientationchange', ['$event'])
  // onOrientationChange(event) {
  //   console.log(event);
  //   if (window.screen.orientation.angle == 90) {
  //     this.toggleFullscreen();
  //   }
  // }

  played() {
    let el = document.querySelector('.plyr');
    el?.classList.add('show_tag');

    if (this.currentUser?.userName) {
      el?.setAttribute('date-user', this.currentUser?.userName);
    } else {
      el?.setAttribute('date-user', 'www.iranoiljob.com');
    }
  }

  playLesson(lessonId: number, chapterId: number) {
    if (this.authService.isAuthenticated) {
      this.courseInformation.chapters.forEach((item: any) => {
        item.lessons.forEach((x: any) => x.isSelected = false);
      });


      let selectedVideoFromChapter = this.courseInformation.chapters.find((item: any) => item.id == chapterId);
      let selectedLesson = selectedVideoFromChapter.lessons.find((item: any) => item.id == lessonId);
      selectedLesson.isSelected = true;

      this.teaserShow = false;
      this.lessonService.getById(lessonId).subscribe((res: any) => {
        if (res?.hlsFileId) {
          this.hlsFileUrl = environment.apiUrl + '/fa/lesson/stream/' + res?.hlsFileId;
        }

        window.scroll(0, 0);
        this.played();
      })
    }
  }

  download(teacherId: number) {
    this.router.navigate([`/academy/lecturer/${teacherId}`], { state: this.courseTitle });
  }

  addComment() {
    if (!this.myForm.get('body')?.value) {
      this.messageService.add({ severity: 'warn', detail: 'متن پیام نمی تواند خالی باشد!' });
      return;
    }

    this.companyCommentService.add(this.myForm.value).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'موفق!',
        detail: 'نظر شما با موفقیت ثبت شد و پس از تایید کارشناسان ما، در قسمت نظرات نمایش داده می شود.'
      });
      this.myForm.get('body')?.setValue(null);
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'خطا!', detail: 'خطایی رخ داده است!' })
    });
  }

  addQuestion() {
    if (!this.questionForm.get('body')?.value) {
      this.messageService.add({ severity: 'warn', detail: 'متن پیام نمی تواند خالی باشد!' });
      return;
    }

    this.companyCommentService.add(this.questionForm.value).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'موفق!',
        detail: 'پرسش شما با موفقیت ثبت شد و بعد از پاسخ مدرس دوره نمایش داده می شود.'
      });
      this.questionForm.get('body')?.setValue(null);
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'خطا!', detail: 'خطایی رخ داده است!' })
    });
  }

  moreComment() {
    this.page += 1;
    this.getComment();
  }

  moreQuestionAndAnswer() {
    this.pageForQuestion += 1;
    this.getComment();
  }

  reply(commentId: number) {
    debugger
    this.comments.forEach((item: any) => item.reply = false);
    let selectedItem = this.comments.find((item: any) => item.id == commentId);
    selectedItem.reply = true;
  }

  disMiss() {
    this.comments.forEach((item: any) => item.reply = false);
  }

  toggleFullscreen() {
    if (!document.fullscreenElement) {
      document.getElementById('video')?.requestFullscreen();
      this.isFullScreen = true;
    } else if (document.exitFullscreen) {
      this.isFullScreen = false;
      document.exitFullscreen();
    }
  }
}
